export default "__VITE_ASSET__CjnGTWjV__"